module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5btYz"))).then(() => parcelRequire('hEqeo'));